/** Lo que el negocio añade al entrar.  (spec 070, bot 072) */

export const TOPE_FRASE = 280

export function largoFrase(s: string): number {
    return [...s].length
}

export function recortarFrase(s: string): string {
    const puntos = [...s]
    return puntos.length <= TOPE_FRASE ? s : puntos.slice(0, TOPE_FRASE).join('')
}

/** Primera variante de `umbral.bienvenida` (tu). El saludo real depende de la hora. */
export function textoBienvenidaAgendify(negocio: string): string {
    const nombre = negocio.trim() || 'este negocio'
    return `Buenos días, soy Agendify, un sistema de inteligencia artificial. Estoy aquí para ayudarte con lo que necesites de los servicios de ${nombre}.`
}

/**
 * La que se dice si el negocio no ha escrito la suya (bot 078).
 * El cuadro del alta enseña esta misma frase.
 */
export function bienvenidaGenerica(o: {
    nombre: string
    servicios: readonly string[]
    trato: 'tu' | 'usted'
}): string {
    const nombre = o.nombre.trim() || 'este negocio'
    const lista = listaDeServicios(o.servicios)
    const usted = o.trato === 'usted'
    const corta = usted
        ? `Encantado de atenderle. Acaba de llegar a ${nombre}. ¿En qué le puedo ayudar?`
        : `Encantado de atenderte. Acabas de llegar a ${nombre}. ¿En qué te puedo ayudar?`
    if (!lista) return corta
    const conOferta = usted
        ? `Encantado de atenderle. Acaba de llegar a ${nombre}. Ofrecemos ${lista}. ¿En qué le puedo ayudar?`
        : `Encantado de atenderte. Acabas de llegar a ${nombre}. Ofrecemos ${lista}. ¿En qué te puedo ayudar?`
    return [...conOferta].length <= TOPE_FRASE ? conOferta : corta
}

function listaDeServicios(nombres: readonly string[]): string {
    const limpios = nombres.map((s) => s.trim()).filter((s) => s.length > 0)
    if (limpios.length === 0) return ''
    if (limpios.length === 1) return limpios[0]!
    return `${limpios.slice(0, -1).join(', ')} y ${limpios[limpios.length - 1]}`
}
